/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-track': {
    width: 8,
    height: 10,
    viewBox: '0 0 8 10',
    data: '<defs><path pid="0" d="M1.222 1.512a3.929 3.929 0 0 1 5.556 5.556L4.354 9.492a.5.5 0 0 1-.708 0L1.222 7.068a3.929 3.929 0 0 1 0-5.556zm4.849.707a2.929 2.929 0 0 0-4.142 4.142L4 8.43l2.07-2.07a2.929 2.929 0 0 0 .119-4.017zM4 2.607a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z" id="svgicon-icon-track-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-icon-track-a" fill-rule="evenodd"/>'
  }
})
